'use strict';

const $LOG = Symbol('log');
const $HTTP = Symbol('http');
const CONTACT = Symbol('contactService');

class ContactController {
  constructor($log, contactService, $http, analyticsService) {
    'ngInject';

    this[$LOG] = $log;
    this[$HTTP] = $http;
    this[CONTACT] = contactService;
    this.message = { type: '', name: '', email: '', message: '' };

    analyticsService.page();
  }


  openModal(type) {
    this.message.type = type;

    if (type === 'support') {
      this.modalTitle = 'Send a message to Support';
      this.modalQuestion = 'How can we help you?';
      this.modalSuccess = 'Thank you! We\'ll get back to you asap.';
    } else {
      this.modalTitle = 'Send a message to Sales';
      this.modalQuestion = 'How can we help you... business-wise?';
      this.modalSuccess = 'Thank you! We\'ll get back to you asap.';
    }
    angular.element('.contact-modal').modal();
  }

  formValid() {
    return this.validateString(this.message.name) &&
      this.validateEmail(this.message.email) &&
      this.validateString(this.message.message);
  }

  submitForm() {
    this[CONTACT].sendEmail(this.message)
       .then(res => {
         if (res.status === 'success') {
           this.message = { type: '', name: '', email: '', message: '' };
           angular.element('.contact-modal').modal('hide');
           angular.element('.contact-modal-success').modal();
         } else {
           this[$LOG].debug(res);
         }
       }
  );
  }

  resetForm() {
    this.message = { type: '', name: '', email: '', message: '' };
  }

  validateEmail(emailString) {
    return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,20})+$/.test(emailString);
  }

  validateString(checkString) {
    return !(checkString === '' || checkString.replace(/^\s+|\s+$/g, '').length === 0);
  }
}

export default ContactController;
